{
  "daytime": {
    "earlier": "Més d'hora",
    "later": "Més tard"
  },
  "login": {
    "title": " Iniciar Sessió",
    "text": "Iniciar sessió al teu compte",
    "button": "Iniciar Sessió",
    "stressLevel": "Nivell d'estrès",
    "errorDialog": {
      "message": "Usuari o contrasenya incorrectes",
      "accept": "D'acord"
    },
    "placeholder": {
      "username": "Si us plau introdueix usuari",
      "password": "Si us plau introdueix contrasenya"
    }
  },
  "sidebar": {
    "bulletins": "Avalanche.report",
    "dangerSources": "Fonts de perill",
    "observations": "Observacions",
    "incidents": "Incidents",
    "qfa": "QFA",
    "modelling": "Modelització",
    "modellingForecast": "Predicció",
    "modellingZamg": "ZAMG multi model",
    "modellingZamgECMWF": "ZAMG ECMWF-EPS",
    "modellingZamgCLAEF": "ZAMG CLAEF-EPS",
    "modellingZamgMeteogram": "Meteograma GeoSphere",
    "modellingSnowpack": "SNOWPACK model",
    "modellingSnowpackMeteo": "SNOWPACK modelled meteo",
    "awsome": "AWSOME",
    "snowpack": "SNOWPACK",
    "geosphere": "GeoSphere",
    "lineaexport": "LINEA",
    "awsstats": "AWS Stats",
    "yearlystats": "Yearly Stats",
    "graphics": "Graphics",
    "icon": "Temps atmosfèric"
  },
  "weather": {
    "loading": "Loading weather parameters and images...",
    "noPng": "Image not found.",
    "error": {
      "noParameters": "No forecast parameters available.",
      "loadFailed": "Could not load forecast data."
    },
    "headings": {
      "model": "Model",
      "modelRun": "Model run",
      "region": "Regió",
      "parameters": "Parameters",
      "level": "Level"
    },
    "alt": {
      "fallback": "Forecast map",
      "image": "{{model}} {{parameter}}{{level}} {{region}} {{date}} {{hour}}Z"
    },
    "models": {
      "icon": "ICON",
      "gfs": "GFS"
    },
    "regions": {
      "atlantic": "Atlantic",
      "europe": "Europe",
      "alps": "Alps",
      "euregio": "EUREGIO"
    },
    "levels": {
      "surface": "Surface",
      "cloudTotal": "Total",
      "cloudHigh": "High",
      "cloudMid": "Mid",
      "cloudLow": "Low"
    },
    "tooltips": {
      "levelApproxElevation": "Approx. elevation: ~{{height}} m"
    },
    "parameters": {
      "gfs": {
        "equivalentPotentialTemp": "Equivalent Potential Temp.",
        "relativeHumidity": "Relative Humidity",
        "geopotentialAndIsotachs": "Geopotential and Isotachs",
        "precipitation": "Precipitation",
        "cape": "CAPE"
      },
      "icon": {
        "cloudCover": "Cloud Cover",
        "ns": "Precipitation 1h",
        "ns24": "Precipitation 24h",
        "nsacc": "Acc. Precipitation",
        "nsprob24gt20": "Prob. Prec. > 20 mm / 24h",
        "nsprob24gt40": "Prob. Prec. > 40 mm / 24h",
        "nsprob24gt80": "Prob. Prec. > 80 mm / 24h",
        "d2m": "Dew Point 2m",
        "gust": "Max. Wind Gust 10m",
        "cape": "MU-CAPE"
      }
    }
  },
  "menu": {
    "logout": "Surt",
    "language": "Idioma",
    "en": "Anglès",
    "de": "Alemany",
    "fr": "Francès",
    "it": "Italià",
    "es": "Castellà",
    "ca": "Català",
    "oc": "Aranès",
    "fullscreen": "Pantalla completa",
    "settings": "Configuració",
    "statistics": "Estadístiques",
    "admin": "Admin",
    "region": "Regió",
    "education": "Educació"
  },
  "matrix": {
    "label": {
      "snowpackStability": "Avaluació de l'estabilitat",
      "frequency": "Freqüència",
      "avalancheSize": "Mida d'allaus",
      "dangerRating": "Grau de perill",
      "override": "(modifica el grau de perill)",
      "matrix": "Matriu",
      "referToFairStability": "Referir-se a una estabilitat regular",
      "referToPoorStability": "Referir-se a una estabilitat pobre",
      "dangerLevel1": "Grau de perill 1 (Feble)"
    }
  },
  "dangerSources": {
    "status": {
      "missing": "falta",
      "available": "disponible",
      "forecast": "predicció",
      "analysis": "anàlisi",
      "loading": "Carregant fonts de perill ...",
      "saveError": "No s'ha pogut desar la font de perill!",
      "loadDangerSourcesError": "No s'han pogut carregar les fonts de perill!",
      "loadVariantsError": "No s'han pogut carregar les variants de la font de perill!",
      "noTitle": "<no title>"
    },
    "variantStatus": {
      "active": "actiu",
      "dormant": "latent",
      "inactive": "inactiu"
    },
    "tooltip": {
      "read": "Llegir fonts de perill",
      "edit": "Editar fonts de perill"
    },
    "table": {
      "loadMore": "Carregar {{count}} més dies",
      "title": {
        "forecast": "Predicció",
        "analysis": "Anàlisi"
      }
    },
    "create": {
      "variantStatus": "Estat",
      "variantEditable": "Aquesta variant es pot editar.",
      "variantNotEditable": "Aquesta variant no es pot editar.",
      "noVariantsForSelectedDay": "No s'han definit variants per a aquesta data.",
      "tooltip": {
        "editDangerSource": "Editar la font de perill",
        "loadVariants": "Carregar variants del dia anterior",
        "loadVariantsFromForecast": "Load variants from forecast",
        "showVariantsOnMap": "Mostrar les variants al mapa",
        "edit": "Editar micro-regions",
        "copy": "Copiar variant",
        "delete": "Esborrar variant",
        "compare": "Comparar variant",
        "forecast": "Comparar amb la predicció"
      },
      "createDangerSource": "Crear font de perill",
      "createVariant": "Crea una nova variant",
      "noDangerSources": "Sense fonts de perill",
      "title": {
        "slab": "Placa",
        "weakLayer": "Capa feble",
        "loose": "Neu sense cohesió",
        "glide": "Lliscament de neu",
        "matrix": "Matriu",
        "characteristics": "Característiques",
        "comment": "Comentari",
        "uncertainties": "Incerteses"
      },
      "label": {
        "glidingSnowActivity": "Activitat de lliscament de neu",
        "snowHeight": "Alçada de la neu",
        "snowHeightLowerLimit": "Min snow height",
        "snowHeightUpperLimit": "Max snow height",
        "snowHeightAverage": "Alçada mitjana de la Neu",
        "zeroDegreeIsotherm": "Isoterma 0°C",
        "looseSnowMoisture": "Humitat de la neu sense cohesió",
        "looseSnowGrainShape": "Forma de gra de la neu sense cohesió",
        "slabGrainShape": "Forma de gra de la placa",
        "slabThickness": "Gruix de la placa",
        "slabThicknessLowerLimit": "Min slab thickness",
        "slabThicknessUpperLimit": "Max slab thickness",
        "slabHandHardness": "Duresa de mà de la placa",
        "slabHandHardnessLowerLimit": "Min slab hand hardness",
        "slabHandHardnessUpperLimit": "Max slab hand hardness",
        "slabHardnessProfile": "Duresa de la placa",
        "slabEnergyTransferPotential": "Potencial de transferència d'energia de la placa",
        "slabDistribution": "Distribució de la placa",
        "weakLayerGrainShape": "Forma de gra de la capa feble",
        "weakLayerGrainShapes": "Weak layer grain shapes",
        "weakLayerGrainSize": "Mida de gra de la capa feble",
        "weakLayerGrainSizeLowerLimit": "Min weak layer grain size",
        "weakLayerGrainSizeUpperLimit": "Max weak layer grain size",
        "weakLayerPersistent": "Capa feble persistent",
        "weakLayerThickness": "Gruix de la capa feble",
        "weakLayerStrength": "Resistència de la capa feble",
        "weakLayerWet": "Capa feble humida",
        "weakLayerCrustAbove": "Crosta a sobre de la capa feble",
        "weakLayerCrustBelow": "Crosta a sota de la capa feble",
        "weakLayerPosition": "Posició de la capa feble",
        "weakLayerCreation": "Creació de la capa feble",
        "weakLayerDistribution": "Distribució de la capa feble",
        "dangerSpotRecognizability": "Reconeixement de punts perillosos",
        "remoteTriggering": "Desencadenament a distància",
        "hasDaytimeDependency": "Dependència de l'hora",
        "dangerIncreaseWithElevation": "Augment del perill amb l'altitud",
        "runoutIntoGreen": "Zona d'arribada cap al verd",
        "penetrateDeepLayers": "Penetrar capes profundes",
        "highestDangerAspect": "Orientació més perillosa",
        "dangerPeak": "Pic de perill",
        "slopeGradient": "Gradient de pendent",
        "naturalRelease": "Desencadenament natural",
        "terrainTypes": "Tipus de terreny",
        "dangerSigns": "Senyals de perill",
        "aspects": "Orientacions"
      },
      "createDangerSourceDialog": {
        "title": "Títol",
        "description": "Descripció",
        "save": "Desar",
        "cancel": "Cancel·lar"
      },
      "editDangerSourceDialog": {
        "title": "Títol",
        "description": "Descripció",
        "update": "Actualització",
        "cancel": "Cancel·lar"
      },
      "deleteVariantDialog": {
        "message": "Vols suprimir aquesta variant?",
        "accept": "Si",
        "reject": "No"
      },
      "noRegionDialog": {
        "message": "Com a mínim una microregió ha de ser teva.",
        "accept": "D'acord"
      },
      "discardDialog": {
        "message": "Vols descartar els canvis?",
        "accept": "Si",
        "reject": "No"
      },
      "saveErrorDialog": {
        "message": "S'ha produït un error en desar les fonts de perill!",
        "accept": "D'acord"
      },
      "loadDialog": {
        "message": "Do you want to load all danger source variants from the day before?<br><strong>Existing analysis variants will be overwritten.</strong>",
        "accept": "Si",
        "reject": "No"
      },
      "loadFromForecastDialog": {
        "message": "Do you want to load all variants from the forecast?<br><strong>Existing analysis variants will be overwritten.</strong>",
        "accept": "Si",
        "reject": "No"
      }
    }
  },
  "avalancheType": {
    "title": "Tipus d'allau",
    "slab": "slab",
    "loose": "loose",
    "glide": "glide",
    "cornice": "cornisa",
    "unknown": "desconegut",
    "label": {
      "slab": "PLACA",
      "loose": "SENSE COHESIÓ",
      "glide": "LLISCAMENT"
    },
    "tooltip": {
      "slab": "Allau de placa",
      "loose": "Allau sense cohesió",
      "glide": "Allau de lliscament de neu"
    }
  },
  "elevation": {
    "title": "Altitud",
    "high": "Per sota",
    "low": "Per sobre",
    "treeline": "Límit del bosc"
  },
  "bulletins": {
    "title": "Avalanche.report",
    "tooltip": {
      "edit": "Editar butlletí",
      "read": "Llegir butlletí",
      "copy": "Copiar el butlletí",
      "paste": "Enganxar el butlletí",
      "cancel": "Cancel·lar la còpia",
      "update": "Editar",
      "submit": "Enviar",
      "submitUpdate": "Enviar actualizacion",
      "publishChange": "Publicar ara (sense missatges)",
      "publishUpdate": "Publicar ara",
      "publishMinimal": "Minimal publication",
      "caaml": "Mostrar CAAML",
      "json": "Mostrar JSON",
      "create": "Crear butlletí",
      "preview": "Previsualitzar el butlletí (PDF)",
      "check": "Comprovar el butlletí",
      "info": "Mostrar l'estat de publicació",
      "loadSuggestionFromDangerSources": "Load suggestion from danger sources",
      "deleteAllWarningRegions": "Suprimeix totes les regions de predicció",
      "publishAll": "Publicar totes les regions",
      "publishAllNoMessages": "Publica totes les regions (sense missatges)",
      "mediaFile": "Carregar un fitxer multimèdia",
      "publicationChecklist": "Open publication checklist"
    },
    "publicationChecklist": {
      "title": "Publication checklist",
      "description": {
        "website": "The map on the website shows the danger levels with their corresponding colors. Clicking on a region shows the avalanche problems and texts.",
        "email": "An email was sent and contains a report.",
        "telegram": "A message containing a link to the website was posted.",
        "whatsapp": "A message containing a link to the website was posted."
      },
      "ok": "D'acord",
      "problem": "Problem",
      "problemDescription": "Problem description",
      "problemPlaceholder": "Describe the encountered problem",
      "channel": {
        "website": "Website",
        "whatsapp": "WhatsApp",
        "telegram": "Telegram",
        "email": "Email"
      },
      "publicationInProgress": "Publication in progress",
      "publicationFinishedOnServer": "Finished publication on server",
      "publishDisabled": {
        "inProgress": "Publication is currently in progress.",
        "wrongStatus": "The bulletin must be submitted or published."
      },
      "emailWaitHint": "Email delivery usually takes longer than social media messages. At least 5 minutes should have passed since publication before you proceed to the next step.",
      "email": {
        "waitTitle": "Wait:"
      },
      "options": "Options",
      "republish": "Republish:",
      "resend": "Resend:",
      "website": {
        "checkInternetTitle": "Check internet connection:",
        "checkInternetDescriptionPrefix": "How is the internet connection on your device? Open",
        "checkInternetDescriptionSuffix": "in a private window. Is yesterday's bulletin displayed correctly?",
        "republishHint": "Only perform this step if “Check internet connection” was successful and at least 5 minutes have passed since the last publication attempt.",
        "publishMinimalTitle": "Minimal publication:",
        "publishMinimalHint": "Use this as a fallback if the full publication fails. Publishes CAAML data only — no maps, text-to-speech, or push messages. ⚠️ Also affects other regions on this server, not just your own. All will be republished in minimal mode.",
        "editAndResendTitle": "Edit and resend:",
        "openBulletin": "Open the bulletin",
        "clickEdit": "Click “Edit”",
        "clickSubmit": "Click “Submit”",
        "clickPublishNow": "Click “Publish now”"
      },
      "manualSend": {
        "title": "Manual send:",
        "description": {
          "telegram": "Copy the text below and send it to the specified Telegram group.",
          "whatsapp": "Copy the text below to the specified WhatsApp channel."
        },
        "copyText": "Copy {{language}} {{channel}} text"
      },
      "newChecklist": "New checklist",
      "savedInfo": "Saved by {{user}}, {{time}}",
      "print": {
        "contact": {
          "title": "Emergency contact",
          "emailLabel": "Email:",
          "nameLabel": "Name:",
          "phoneLabel": "Phone:"
        },
        "emergencyTitle": "If serious problems occur",
        "fallback": {
          "title": "Use fallback instance:",
          "step1": "Navigate to the fallback Admin-GUI and publish the bulletin there.",
          "step2": "Manually send messages to subscribed channels. Use the text below:",
          "step3": "Inform the public by creating social media posts linking to the fallback website URL.",
          "step4": "Inform the PR department about the situation."
        },
        "hide": "Hide print version",
        "hint": "Fill in the hosting service contact details and the fallback URLs below, then click \"Print\".",
        "hostingDescription": "Ask about server status. If applicable, request a server restart.",
        "hostingTitle": "Contact hosting service:",
        "print": "Print",
        "toggle": "Print version"
      }
    },
    "status": {
      "submittedInfo": "Serà publicat a les 5PM",
      "resubmittedInfo": "Serà publicat a les 8AM",
      "publishedInfo": "Ha estat publicat",
      "noPublicationInfo": "NO serà publicat automàticament",
      "loadingPreview": "S'està creant la previsualització de PDF ...",
      "loading": "Butlletí carregant-se ...",
      "loadMoreBulletins": "Carregar {{count}} més butlletins",
      "publishing": "Butlletí publicant-se ...",
      "submitting": "Butlletí enviant-se ...",
      "saveError": "No s'ha pogut desar el butlletí!",
      "loadBulletinsError": "No s'han pogut carregar els butlletins!"
    },
    "create": {
      "tooltip": {
        "edit": "Editar micro-regions",
        "copy": "Copiar regió",
        "delete": "Esborrar regió",
        "deleteProblem": "Eliminar el problema",
        "compare": "Comparar regió",
        "undo": "Desfés l'últim canvi a la regió",
        "redo": "Refés el canvi a la regió",
        "createRegion": "Crear regió",
        "cancel": "Cancel·lar",
        "acceptSuggestion": "Acceptar les regions proposades",
        "rejectSuggestion": "No acceptar les regions proposades",
        "saveChanges": "Guardar els canvis",
        "discardChanges": "Descartar els canvis",
        "incompleteAvalancheProblem": "Problema d'allaus incomplet",
        "saveBulletin": "Guardar el butlletí",
        "discardBulletin": "Descartar els canvis al butlletí",
        "loadBulletin": "Carregar el butlletí d'ahir",
        "uploadCaamlBulletin": "Upload bulletin in CAAML format",
        "uploadJsonBulletin": "Carregar el butlletí en format JSON",
        "downloadCaamlBulletin": "Download bulletin in CAAML format",
        "downloadJsonBulletin": "Descarregar el butlletí en format JSON",
        "daytimeDependency": "Dependència de l'hora",
        "treeline": "Límit del bosc",
        "tendency": {
          "decreasing": "El perill d'allaus disminueix",
          "steady": "El perill d'allaus roman estable",
          "increasing": "El perill d'allaus augmenta",
          "danger": "Perill d'allaus"
        },
        "textcat": {
          "edit": "Editar",
          "copy": "Copiar",
          "paste": "Enganxar",
          "example": "Carregar text d'exemple",
          "delete": "Esborrar"
        },
        "moveUpAvalancheProblem": "Moure el problema d'allaus cap amunt",
        "moveDownAvalancheProblem": "Moure el problema d'allaus cap avall",
        "dangerRatingDirectionUp": "Cap amunt",
        "dangerRatingDirectionDown": "Cap avall",
        "addPhoto": "Add photo",
        "removePhoto": "Remove photo",
        "uploadPhoto": "Upload photo",
        "editPhoto": "Edit photo"
      },
      "save": "Desar",
      "discard": "Descartar",
      "back": "Enrera",
      "createAggregatedRegion": "Nova regió",
      "pasteAggregatedRegion": "Enganxar la regió",
      "pendingSuggestions": "Suggeriments",
      "rejectSuggestion": "Rebutjar",
      "acceptSuggestion": "Acceptar",
      "cancelCopyBulletin": "Cancel·lar",
      "createAvalancheProblem": "Nou problema",
      "ownRegions": "Regions pròpies",
      "foreignRegions": "Regions alienes",
      "externalRegions": "Regions externes",
      "mapSelectRegion": "Seleccionar regions al mapa",
      "statusHeader": "Estat del butlletí",
      "suggestions": "Suggeriments",
      "noBulletinsForSelectedDay": "Cap regió definida per aquesta data.",
      "autosave": "Gaurdat automàticament",
      "regionEditable": "Aquesta regió pot editar-se",
      "regionNotEditable": "Aquesta regió no pot editar-se",
      "regionLocked": "Aquesta regió està bloquejada",
      "changeDangerRatingElevation": "Extendre el perill d'allaus",
      "mapTop": "Mapa a sobre",
      "mapLeft": "Mapa al costat",
      "showExternalRegions": "Mostrar les regions externes",
      "hideExternalRegions": "Amagar les regions externes",
      "showNotes": "Mostrar notes",
      "hideNotes": "Amagar notes",
      "incompleteAvalancheProblem": "Incomplet",
      "label": {
        "generalHeadlineComment": "Títol general",
        "importantObservations": "Observacions importants",
        "avalancheProblems": "Problema d'allaus",
        "aspects": "Orientacions",
        "highlights": "Alerta especial",
        "avActivityHighlights": "Titular de la situació d'allaus",
        "avActivityComment": "Descripció del perill d'allaus",
        "travelAdvisoryHighlights": "Headline travel advisory",
        "travelAdvisoryComment": "Description of travel advisory",
        "snowpackStructureHighlights": "Titular estructura mantell",
        "snowpackStructureComment": "Descripció de l'estructura del mantell",
        "dangerPatterns": "Patrons de perill",
        "tendencyComment": "Descripció de la tendència",
        "synopsisHighlights": "Headline weather synopsis",
        "synopsisComment": "Sinopsi meteorològica",
        "notes": "Notes",
        "noSnow": "Sense neu"
      },
      "copyRegion": {
        "label": "Copiar regió d'alerta a un altre butlletí",
        "select": "Enganxar a ...",
        "currentBulletin": "Aquest butlletí"
      },
      "title": {
        "avalancheProblem": "Problemes d'allaus",
        "dangerDescription": "Descripció del perill d'allaus",
        "forenoon": "Matí",
        "afternoon": "Tarda",
        "photos": "Photos",
        "snowpackStructure": "Estructura del mantell",
        "tendency": "Tendència",
        "synopsis": "Temps atmosfèric",
        "showTranslations": "-mostra traduccions",
        "hideTranslations": "Amaga traduccions"
      },
      "photos": {
        "url": "Image URL",
        "locationName": "Localitat",
        "microregion": "Microregion",
        "copyright": "Copyright",
        "date": "Data"
      },
      "placeholder": {
        "notes": "Escriu aquí..."
      },
      "pmDialog": {
        "noIFrameSupport": "El teu navegador no admet Iframes!"
      },
      "discardDialog": {
        "message": "Vols descartar els canvis?",
        "accept": "Si",
        "reject": "No"
      },
      "deleteAggregatedRegionDialog": {
        "message": "Vols esborrar aquesta regió?",
        "accept": "Si",
        "reject": "No"
      },
      "noRegionDialog": {
        "message": "Com a mínim una microregió ha de ser teva.",
        "accept": "Ok"
      },
      "loadDialog": {
        "message": "Do you want to load the bulletins from the day before?<br><strong>This will delete all existing regions!</strong>",
        "accept": "Si",
        "reject": "No"
      },
      "deleteAllWarningRegionsDialog": {
        "message": "Voleu suprimir totes les regions de predicció?",
        "accept": "Si",
        "reject": "No"
      },
      "loadSuggestionsFromDangerSourcesDialog": {
        "message": "Do you want to load suggestions from danger sources?<br><strong>This will delete all existing regions!</strong>",
        "accept": "Si",
        "reject": "No"
      },
      "loadAutoSaveDialog": {
        "message": "Vols carregar els butlletins guardats automàticament?",
        "accept": "Si",
        "reject": "No"
      },
      "saveErrorDialog": {
        "message": "Hi ha hagut un error guardant els butlletins!",
        "accept": "D'acord"
      },
      "changeErrorDialog": {
        "message": "Hi ha hagut un error canviant els butlletins!",
        "accept": "D'acord"
      },
      "loadingErrorDialog": {
        "message": "Hi ha hagut un error llegint els butlletins!",
        "accept": "D'acord"
      },
      "loadingJsonFileErrorDialog": {
        "message": "S'ha produït un error en carregar els butlletins des del fitxer JSON!",
        "accept": "D'acord"
      },
      "avalancheProblemErrorDialog": {
        "message": "Falta el problema d'allaus, orientacions, estabilitat del mantell de neu, freqüència i/o la mida d'allaus per almenys un problema d'allaus",
        "accept": "D'acord"
      },
      "loadAvActivityCommentExampleTextDialog": {
        "message": "Per quina situació vols carregar un text d'exemple?",
        "newSnow": "Neu recent",
        "windSlab": "Plaques de vent",
        "persistentWeakLayers": "Capes febles persistents",
        "wetSnow": "Neu humida",
        "glidingSnow": "Lliscaments",
        "favourableSituation": "Situació favorable",
        "cancel": "Cancel·lar"
      },
      "removeDaytimeDependencyDialog": {
        "message": "Quins problemes d'allaus voleu mantenir?",
        "cancel": "Cancel·lar"
      },
      "strategicMindsetDialog": {
        "title": "Predisposicions mentals estratègiques",
        "introduction": "Les \"predisposicions mentals estratègiques\" tenen com a objectiu expressar la nostra actitud mental respecte a la situació d'allaus i el seu desenvolupament a la regió d'alerta corresponent. No s'ha de derivar directament de l'avaluació del perill, sinó que s'ha d'entendre i utilitzar com una impressió intuïtiva de la situació general. Per tant, les \"predisposicions mentals estratègiques\" són principalment una eina de comunicació. Utilitzant les predisposicions i les definicions associades, nosaltres, els predictors, podem intercanviar informació de manera ràpida i eficient sobre el desenvolupament de la situació de perill i trobar un llenguatge comú per a la comunicació.",
        "description": {
          "title": "Descripció:",
          "text": {
            "assessment": "Hi ha una <b>gran incertesa</b> en l'avaluació del perill a causa de la <b>manca d'informació</b> de camp.",
            "stepping_out": "<b>Tendència decreixent</b> de la situació de perill (també dins d'un nivell de perill).",
            "status_quo": "Mateixa situació perillosa. <b>Sense canvis significatius</b> respecte al dia anterior.",
            "stepping_back": "<b>Tendència creixent</b> de la situació de perill (també dins d'un nivell de perill).",
            "entrenchment": "<b>Situació perillosa, constant i tensa.</b> El perill principal prové d'una o més (a) <b>capa feble persistent</b>(s) susceptible a desencadenar-se.",
            "free_ride": "<b>Perill d'allaus feble</b> amb un mantell de neu generalment estable. Només són possibles petites allaus en terreny extremadament inclinat.",
            "high_alert": "Situació excepcional amb <b>perill d'allaus fort o molt fort</b>. Són possibles allaus naturals de magnitud <b>molt gran o extrema</b>",
            "spring_diurnal": "Les allaus de neu humida durant el transcurs del dia, que estan subjectes a un <b>cicle diürn clar</b>, són decisives per a l'avaluació del risc."
          }
        },
        "communication": {
          "title": "Comunicació:",
          "text": {
            "assessment": "Cal comprovar localment la situació d'allaus. Es recomana restricció.",
            "stepping_out": "Disminució gradual del perill. No obstant això, encara cal precaució i la millora de la situació s'ha d'avaluar localment abans d'entrar en terreny més arriscat.",
            "status_quo": "La situació perillosa no ha canviat. Els comentaris dels observadors ajuden a definir millor la situació perillosa. Cal comunicar amb èmfasi un terreny més favorable.",
            "stepping_back": "Comunicació clara de l'augment del perill d'allaus, fins i tot dins d'un nivell de perill. La informació sobre les causes afavoreix la comprensió de la comunicació.",
            "entrenchment": "Cal precaució i contenció. La situació gairebé no canvia. Si és possible, proporciona informació el més precisa possible sobre la distribució i la possibilitat de desencadenament. Més comunicació de les observacions que revelen la situació i causen la restricció.",
            "free_ride": "Poc text. Destaca la situació general favorable i les zones de perill potencialment aïllades.",
            "high_alert": "Comunicació a través de tots els canals. L'atenció ja no se centra en els esports d'hivern. Perill fins i tot en zones que no solen tenir risc d'allaus.",
            "spring_diurnal": "Situació favorable al matí, que augmentarà durant el dia. L'avaluació s'ha de fer localment observant l'estovament de la crosta de fusió i regel i la humidificació del mantell de neu."
          }
        },
        "examples": {
          "title": "Exemples:",
          "text": {
            "assessment": "Inici de la temporada.",
            "stepping_out": "El refredament disminueix el risc d'allaus de neu humida després d'una fase de temps càlid i humit.",
            "status_quo": "Problema de plaques de vent consistent amb temperatures fredes, neu sense cohesió i vent.",
            "stepping_back": "La nevada abundant recent provoca un augment de la situació de perill.",
            "entrenchment": "Problema crític de capes febles persistents amb potencial d'allaus perillosament grans. La situació s'està estabilitzant molt lentament i requereix molta restricció.",
            "free_ride": "Perill d'allaus feble, sense capes febles persistents, tot el terreny ja està trepitjat.",
            "high_alert": "Nivell de perill 4 o superior a causa de gran quantitat de neu nova i/o capes febles problemàtiques i persistents.",
            "spring_diurnal": "Situació primaveral amb temps sec, pressió alta i temperatures moderades amb un mantell de neu vell majoritàriament estable."
          }
        },
        "strategicMindset": {
          "assessment": "Incertesa elevada",
          "stepping_out": "Millorant",
          "status_quo": "Status Quo",
          "stepping_back": "Deteriorament",
          "entrenchment": "Inestable persistent",
          "free_ride": "Favorable",
          "high_alert": "Alerta màxima",
          "spring_diurnal": "Primavera al llarg del dia"
        }
      },
      "decisionTree": {
        "filepath": "./assets/img/decision_tree-en.svg",
        "feedbackURL": "https://admin.avalanche.report/umfrage-entscheidungsbaum/en/",
        "decisionTree": "Arbre de decisions",
        "feedback": "Comentaris",
        "save": "Desar",
        "discard": "Descarta"
      }
    },
    "table": {
      "title": {
        "date": "Data"
      },
      "status": {
        "missing": "falta",
        "draft": "esborrany",
        "submitted": "enviat",
        "published": "publicat",
        "updated": "actualitzat",
        "resubmitted": "re-enviat",
        "republished": "re-publicat"
      },
      "publishBulletinsDialog": {
        "message": "Vols publicar el butlletí?"
      },
      "publicationStatusDialog": {
        "headline": "Estat de la publicació",
        "publishedBy": "Publicat per:",
        "publishedAt": "Publicat a les:",
        "validFor": "Vàlid per:",
        "title": {
          "prod": "Coses serioses",
          "test": "Test del sistema",
          "task": "Tasca",
          "language": {
            "all": "TOTS",
            "de": "DE",
            "it": "IT",
            "en": "EN"
          }
        },
        "email": {
          "label": "Emails",
          "tooltip": "Enviar Emails",
          "success": "Correus electrònics enviats correctament!",
          "error": "No s'han pogut enviar els correus electrònics!"
        },
        "telegram": {
          "label": "Missatges Telegram",
          "tooltip": "Enviar missatges de Telegram",
          "success": "Missatges de Telegram enviats correctament!",
          "error": "No s'han pogut enviar els missatges de Telegram!"
        },
        "whatsapp": {
          "label": "Missatges de WhatsApp",
          "tooltip": "Enviar missatges de WhatsApp",
          "success": "Missatges de WhatsApp enviats correctament!",
          "error": "No s'han pogut enviar els missatges de WhatsApp!"
        },
        "push": {
          "label": "Notificacions push",
          "tooltip": "Enviar notificacions push",
          "success": "Notificacions push enviades correctament!",
          "error": "No s'han pogut enviar les notificacions push!"
        },
        "accept": "D'acord",
        "confirm": "Do you want to send {{channel}} ({{language}})?"
      },
      "mediaFileDialog": {
        "headline": "Fitxer multimèdia",
        "important": "IMPORTANT",
        "missingFile": "No s'ha seleccionat cap fitxer!",
        "uploadError": "La càrrega ha fallat!",
        "accept": "Enviar",
        "reject": "Cancel·la"
      },
      "publishBulletinsErrorDialog": {
        "message": "Hi ha hagut un error publicant els butlletins!",
        "accept": "D'acord"
      },
      "submitBulletinsDialog": {
        "message": "Vols enviar el butlletí?"
      },
      "submitBulletinsErrorDialog": {
        "message": "Hi ha hagut un error pujant els butlletins!",
        "accept": "D'acord"
      },
      "submitBulletinsDuplicateRegionDialog": {
        "message": "Regions graduades més d'un cop! El butlletí no es pot pujar",
        "accept": "D'acord"
      },
      "checkBulletinsErrorDialog": {
        "message": "Hi ha hagut un error comprovant els butlletins!",
        "accept": "D'acord"
      },
      "previewErrorDialog": {
        "message": "No s'ha pogut carregar la previsualització.",
        "accept": "D'acord"
      },
      "checkBulletinsDialog": {
        "message": "Comprovar el butlletí",
        "ok": "(tot correcte)"
      },
      "publishAllDialog": {
        "message": "Vols publicar totes les regions?",
        "changeMessage": "Voleu publicar totes les regions? (sense missatges)"
      },
      "bulletinCheck": {
        "missingDangerRating": "Grau de perill no especificat ",
        "missingDangerRatingModificator": "Danger rating modificator not set",
        "missingRegion": "Regions sense graduar",
        "duplicateRegion": "Regions graduades més d'un cop",
        "missingAvActivityHighlights": "Falta el titular de la situació d'allaus",
        "missingAvActivityComment": "Falta la descripció del perill d'allaus",
        "missingSnowpackStructureHighlights": "Falta titular estructura mantell",
        "missingSnowpackStructureComment": "Falta la descripció de l'estructura del mantell",
        "pendingSuggestions": "Suggeriments pendents",
        "incompleteTranslation": "Traducció incompleta"
      }
    }
  },
  "training": {
    "training": "Entrenament",
    "timestamp": "Marca de temps d'entrenament"
  },
  "admin": {
    "loadingStatistics": "Creant el CSV ...",
    "server-configuration": {
      "title": "Servidor",
      "button": {
        "create": "Crear servidor",
        "save": "Desar"
      },
      "table": {
        "name": "Nom",
        "userName": "Nom d'usuari",
        "password": "Contrasenya",
        "publishAt5PM": "Publica a les 5 PM",
        "publishAt8AM": "Publica a les 8 AM",
        "pdfDirectory": "Directori per PDF",
        "htmlDirectory": "Directori per HTML",
        "serverImagesUrl": "Adreça de les imatges del servidor",
        "dangerLevelElevationDependency": "Dependència de l'altitud del grau de perill",
        "mapsPath": "Adreça dels mapes",
        "mediaPath": "Ruta dels fitxers multimèdia",
        "mapProductionUrl": "URL per la producció dels mapes",
        "apiUrl": "API URL"
      },
      "success": "Configuració guardada satisfactòriament",
      "error": "No es pot guardar la contrasenya"
    },
    "region-configuration": {
      "title": "Regió",
      "button": {
        "create": "Crear regió",
        "save": "Desar"
      },
      "table": {
        "general": {
          "title": "General"
        },
        "publication": {
          "title": "Publicació"
        },
        "components": {
          "title": "Components"
        },
        "configuration": {
          "title": "Configuració"
        },
        "languageConfiguration": {
          "title": "Configuració de llengües"
        }
      },
      "success": "Configuració guardada satisfactòriament",
      "error": "No es pot guardar la contrasenya"
    },
    "users": {
      "title": "Usuaris",
      "button": {
        "create": " Crear usuari"
      },
      "tooltip": {
        "edit": "Editar usuari",
        "changePassword": "Canviar la contrasenya",
        "delete": "Esborrar usuari"
      },
      "table": {
        "name": "Nom",
        "email": "Email",
        "organization": "Organizació",
        "regions": "Regions",
        "roles": "Funcions"
      },
      "deleteUserModalDialog": {
        "message": "Voleu eliminar l’usuari?",
        "accept": "Si",
        "reject": "No"
      },
      "deleteUser": {
        "success": "S'ha suprimit l'usuari",
        "error": "No s'ha pogut suprimir l'usuari"
      },
      "createUser": {
        "success": "Usuari creat",
        "error": "No s'ha pogut crear l'usuari"
      },
      "updateUser": {
        "success": "Usuari guardat",
        "error": "No s'ha pogut desar l'usuari"
      }
    },
    "createUser": {
      "table": {
        "image": "Imatge",
        "name": "Nom",
        "email": "Email",
        "organization": "Organizació",
        "password": "Contrasenya",
        "password2": "Repetir contrasenya",
        "roles": "Funcions",
        "regions": "Regions"
      },
      "error": {
        "name": {
          "required": "Introduir un nom"
        },
        "email": {
          "required": "Introduir una adreça de correu electrònic",
          "invalid": "L'adreça de correu electrònic no és vàlida"
        },
        "password": {
          "required": "Introduir una contrasenya",
          "length": "La contrasenya ha de tenir com a mínim 8 caràcters",
          "mismatch": "Les contrasenyes no coincideixen"
        }
      },
      "button": {
        "create": "Crear usuari",
        "update": "Actualitzar l'usuari",
        "cancel": "Cancel·lar"
      }
    },
    "observations": {
      "table": "Taula",
      "map": "Mapa",
      "gallery": "Galeria",
      "filters": "Filtres",
      "details": "Detalls",
      "title": "Observacions",
      "newObservation": "Nova observació",
      "exportObservations": "Exportar observacions (GeoJSON)",
      "exportStatistics": "Exportar estadístiques (CSV)",
      "toggleFilterBar": "Mostrar/amagar la barra de filtres",
      "button": {
        "submit": "Descarregar"
      },
      "label": {
        "dateRange": "Període",
        "observer": "Observador"
      },
      "selectRegion": {
        "placeholder": "Regió",
        "selectionLabel": "{0} region(s) seleccionades"
      },
      "selectSources": {
        "placeholder": "Fonts",
        "selectionLabel": "{0} fonts(s) seleccionades"
      },
      "charts": {
        "charts": "Gràfics",
        "nan": "Sense especificar",
        "reload": "Tornar a carregar",
        "classify": "Classificar",
        "label": "Etiqueta",
        "invert": "Invertir",
        "reset": "Restablir",
        "aspect": {
          "caption": "Orientació"
        },
        "elevation": {
          "caption": "Altitud"
        },
        "stability": {
          "caption": "Estabilitat"
        },
        "observationType": {
          "caption": "Tipus d'observació"
        },
        "importantObservation": {
          "caption": "Important"
        },
        "avalancheProblem": {
          "caption": "Problema d'Allaus"
        },
        "dangerPattern": {
          "caption": "Patró de perill"
        },
        "dangerSource": {
          "caption": "Font de Perill"
        },
        "days": {
          "caption": "Dia"
        }
      }
    },
    "blog": {
      "title": "Blog",
      "language": {
        "title": "Idioma",
        "de": "DE",
        "it": "IT",
        "en": "EN"
      },
      "all": {
        "tooltip": "Enviar correus electrònics, Telegram, WhatsApp i Push",
        "success": "Correu electrònic, Telegram, Whatsapp i Push enviats correctament!",
        "error": "No s'ha pogut enviar el correu electrònic, Telegram, WhatsApp ni Push!"
      },
      "email": {
        "tooltip": "Enviar Emails",
        "success": "Correu electrònic enviat correctament!",
        "error": "No s'ha pogut enviar el correu electrònic!"
      },
      "telegram": {
        "tooltip": "Enviar a través del canal de Telegram",
        "success": "Telegram enviat correctament!",
        "error": "No s'ha pogut enviar el telegram!"
      },
      "whatsapp": {
        "tooltip": "Enviar pel canal de WhatsApp",
        "success": "WhatsApp enviat correctament!",
        "error": "No s'ha pogut enviar el WhatsApp!"
      },
      "push": {
        "tooltip": "Enviar mitjançant notificacions push",
        "success": "Push enviat correctament!",
        "error": "No s'ha pogut enviar la comanda Push!"
      }
    }
  },
  "settings": {
    "title": "Configuració",
    "effectiveRole": "Effective role",
    "effectiveRoleDefault": "All roles",
    "changePassword": {
      "title": "Canviar la contrasenya",
      "oldPassword": {
        "label": "Contrasenya actual",
        "placeholder": "Contrasenya actual"
      },
      "newPassword1": {
        "label": "Nova contrasenya",
        "placeholder": "Nova contrasenya"
      },
      "newPassword2": {
        "label": "Contrasenya nova (repetir)",
        "placeholder": "Nova contrasenya"
      },
      "submit": "Canviar la contrasenya",
      "passwordChanged": "Contrasenya canviada",
      "passwordChangeError": "No es pot canviar la contraenya",
      "passwordIncorrect": "La contrasenya actual és incorrecta",
      "error": {
        "oldPassword": {
          "required": "Si us plau introdueix la contrasenya actual"
        },
        "newPassword": {
          "required": "Si us plau introdueix la nova contrasenya",
          "mismatch": "Les contrasenyes no coincideixen"
        }
      }
    },
    "display": {
      "title": "Visualitzar",
      "table": {
        "showCaaml": "Mostrar CAAML",
        "showJson": "Mostrar JSON"
      }
    }
  },
  "statistics": {
    "title": "Estadístiques",
    "bulletins": "Butlletins d'allaus",
    "dangerSources": "Fonts de perill",
    "button": {
      "submit": "Descarregar"
    },
    "label": {
      "dateRange": "Període",
      "extended": "Ampliat",
      "duplicates": "Duplicats"
    },
    "error": {
      "downloadFailed": "The statistics export could not be downloaded. Please try again."
    }
  },
  "dangerRating": {
    "missing": "falta",
    "noRating": "Sense grau de perill",
    "no_rating": "Sense grau de perill",
    "no_snow": "no snow",
    "low": "Feble",
    "moderate": "Moderat",
    "considerable": "Marcat",
    "high": "Fort",
    "very_high": "molt fort",
    "veryHigh": "Molt fort"
  },
  "avalancheProblem": {
    "newSnow": "Neu recent",
    "new_snow": "Neu recent",
    "windSlab": "Plaques de vent",
    "wind_slab": "Plaques de vent",
    "persistentWeakLayers": "Capes febles persistents",
    "persistent_weak_layers": "Capes febles persistents",
    "wetSnow": "Neu humida",
    "wet_snow": "Neu humida",
    "glidingSnow": "Lliscaments",
    "gliding_snow": "Lliscaments",
    "cornices": "Cornises",
    "noDistinctAvalancheProblem": "Cap problema d'allaus evident",
    "no_distinct_avalanche_problem": "Cap problema d'allaus evident",
    "favourableSituation": "Situació favorable",
    "favourable_situation": "Situació favorable"
  },
  "dangerPattern": {
    "dp1": "pp.1: capa feble persistent profunda",
    "dp2": "pp.2: allaus de lliscament",
    "dp3": "pp.3: pluja",
    "dp4": "pp.4: fred després de temperat / temperat després de fred",
    "dp5": "pp.5: nevada després d'un llarg període fred",
    "dp6": "pp.6: neu freda i solta i vent",
    "dp7": "pp.7: mantell de neu prim vora mantell de neu gruixut",
    "dp8": "pp.8: gebre enterrat",
    "dp9": "pp.9: neu rodona enterrada",
    "dp10": "pp.10: escenari de primavera"
  },
  "strategicMindset": {
    "title": "Predisposició mental estratègica",
    "assessment": "Incertesa elevada",
    "stepping_out": "Millorant",
    "status_quo": "Status Quo",
    "stepping_back": "Deteriorament",
    "entrenchment": "Inestable persistent",
    "free_ride": "Favorable",
    "high_alert": "Alerta màxima",
    "spring_diurnal": "Primavera al llarg del dia"
  },
  "observationType": {
    "DrySnowfallLevel": "Cota de neu seca de la nevada",
    "TimeSeries": "Sèrie temporal",
    "Incident": "Incident",
    "Profile": "Perfil de neu",
    "Closure": "Tancament",
    "Blasting": "Voladura",
    "Avalanche": "Allau",
    "Evaluation": "Avaluació",
    "SimpleObservation": "Observació simple",
    "Webcam": "Webcam"
  },
  "importantObservation": {
    "ForBlog": "Pel blog",
    "SurfaceHoar": "Gebre de superfície",
    "Graupel": "Neu granulada",
    "StabilityTest": "Test d'estabilitat",
    "IceFormation": "Formació de gel",
    "VeryLightNewSnow": "Neu recent molt lleugera"
  },
  "elevationTolerance": {
    "exact": "exacte",
    "50m": "±50m",
    "100m": "±100m",
    "200": "±200m"
  },
  "elevationPeriod": {
    "duringPrecipitationEvent": "Límit de neu seca per a tot l'esdeveniment de precipitació",
    "observationPeriod": "Límit de neu seca en el moment de l'observació"
  },
  "aspect": {
    "N": "N",
    "NE": "NE",
    "E": "E",
    "SE": "SE",
    "S": "S",
    "SW": "SW",
    "W": "W",
    "NW": "NW"
  },
  "role": {
    "SUPERADMIN": "Super-Administrador",
    "ADMIN": "Administrador",
    "FORECASTER": "Predictor",
    "FOREMAN": "Mestre d'obres",
    "OBSERVER": "Observador"
  },
  "tendency": {
    "decreasing": "El perill d'allaus disminueix",
    "steady": "El perill d'allaus roman estable",
    "increasing": "El perill d'allaus augmenta"
  },
  "snowpackStability": {
    "unknown": "desconegut",
    "good": "bona",
    "fair": "regular",
    "poor": "pobre",
    "very_poor": "molt pobre"
  },
  "frequency": {
    "none": "(gairebé) cap",
    "few": "unes poques",
    "some": "algunes",
    "many": "moltes"
  },
  "avalancheSize": {
    "small": "petita",
    "medium": "mitjana",
    "large": "gran",
    "very_large": "molt gran",
    "extreme": "extremadament gran"
  },
  "complexity": {
    "easy": "Fàcil",
    "challenging": "Exigent",
    "complex": "Complex"
  },
  "glidingSnowActivity": {
    "low": "Feble",
    "medium": "mitjana",
    "high": "fort"
  },
  "wetness": {
    "dry": "seca",
    "moist": "humida",
    "wet": "molt humida"
  },
  "characteristic": {
    "low": "Feble",
    "medium": "mitjana",
    "high": "fort",
    "very_high": "molt fort"
  },
  "thickness": {
    "thin": "prim",
    "thick": "gruixut"
  },
  "snowpackPosition": {
    "upper": "superior",
    "middle": "mig",
    "lower": "inferior",
    "ground": "terra"
  },
  "weakLayerCrust": {
    "no": "no",
    "partly": "parcialment",
    "yes": "sí"
  },
  "creationProcess": {
    "radiation_recrystallization": "radiació",
    "diurnal_recrystallization": "diürn",
    "melt_layer_recrystallization": "capa de fusió",
    "surface_hoar_formation": "gebre de superfície"
  },
  "recognizability": {
    "very_easy": "molt fàcil",
    "easy": "fàcil",
    "hard": "difícil",
    "very_hard": "molt difícil"
  },
  "distribution": {
    "isolated": "aïllat",
    "specific": "específic",
    "widespread": "generalitzat"
  },
  "probability": {
    "likely": "probable",
    "possible": "possible",
    "unlikely": "poc probable"
  },
  "detailedDaytime": {
    "evening": "vespre",
    "first_night_half": "primera part de la nit",
    "second_night_half": "segona part de la nit",
    "morning": "matí",
    "forenoon": "matí",
    "afternoon": "tarda"
  },
  "slopeGradient": {
    "moderately_steep": "moderadament inclinat",
    "steep": "inclinat",
    "very_steep": "molt inclinat",
    "extremely_steep": "extremadament inclinat"
  },
  "handHardness": {
    "fist": "P",
    "four_fingers": "4D",
    "one_finger": "1D",
    "pencil": "L",
    "knife": "G",
    "ice": "I"
  },
  "hardnessTendency": {
    "decreasing": "més tou a sota",
    "steady": "uniforme",
    "increasing": "més tou a sobre"
  },
  "terrainType": {
    "gullies_and_bowls": "canals i cubetes",
    "adjacent_to_ridgelines": "adjacent a crestes",
    "distant_from_ridgelines": "lluny de les crestes",
    "in_the_vicinity_of_peaks": "prop dels cims",
    "pass_areas": "prop de colls",
    "shady_slopes": "vessants obacs",
    "sunny_slopes": "vessants solans",
    "grassy_slopes": "vessants herbosos",
    "cut_slopes": "talussos",
    "wind_loaded_slopes": "vessants amb plaques de vent",
    "base_of_rock_walls": "a la base de parets rocoses",
    "behind_abrupt_changes_in_the_terrain": "sota canvis abruptes de terreny",
    "transitions_into_gullies_and_bowls": "transicions a canals i cubetes",
    "areas_where_the_snow_cover_is_rather_shallow": "zones on el mantell de neu és força prim",
    "transitions_from_a_shallow_to_a_deep_snowpack": "transicions de mantell de neu prim a gruixut",
    "highly_frequented_off_piste_terrain": "terreny fora-pista molt freqüentat",
    "little_used_backcountry_terrain": "terreny de muntanya poc utilitzat",
    "places_that_are_protected_from_the_wind": "llocs protegits del vent",
    "regions_exposed_to_the_foehn_wind": "regions exposades al Fogony",
    "regions_with_a_lot_of_snow": "regions amb molta neu",
    "regions_exposed_to_precipitation": "regions exposats a la precipitació",
    "regions_exposed_to_heavier_precipitation": "regions exposats a precipitació abundant"
  },
  "dangerSign": {
    "shooting_cracks": "fissures que propaguen",
    "whumpfing": "whumpfing",
    "fresh_avalanches": "allaus recents",
    "glide_cracks": "esquerdes de lliscament"
  },
  "changeRegionDialog": {
    "message": "Vols canviar de regió?",
    "accept": "Si",
    "reject": "No"
  },
  "zamg": {
    "table": "Taula",
    "map": "Mapa",
    "region": "Regió",
    "newSnow": "Neu recent"
  },
  "snowpack": {
    "plotType": {
      "LWC_stratigraphy": "Neu humida: contingut d'aigua líquida",
      "wet_snow_instability": "Neu humida: Inestabilitat de neu humida",
      "Sk38_stratigraphy": "Capes febles persistents: Índex d'estabilitat SK38",
      "stratigraphy": "Capes febles persistents: estratigrafia de la neu"
    },
    "aspect": {
      "flat": "pla",
      "north": "nord",
      "south": "sud"
    },
    "meteo": {
      "new_snow_plot_3day": "neu nova (3d)",
      "new_snow_plot_7day": "neu nova (7d)",
      "new_snow_plot_1month": "neu nova (31d)",
      "new_snow_plot_season": "neu nova (temporada)",
      "new_snow_plot_forecast": "neu nova (previsió)",
      "wet_snow_plot_3day": "neu humida (3d)",
      "wet_snow_plot_7day": "neu humida (7d)",
      "wet_snow_plot_1month": "neu humida (31d)",
      "wet_snow_plot_season": "Neu humida (temporada)",
      "wet_snow_plot_forecast": "Neu humida (previsió)",
      "HS_table_24h": "taula d'alçada de la neu (1d)",
      "HS_table_72h": "taula d'alçada de la neu (3d)",
      "HS_table_season": "taula d'alçada de la neu (temporada)",
      "HS_table_forecast": "taula d'alçada de la neu (previsió)",
      "TA_table_24h": "taula de temperatures (1d)",
      "TA_table_72h": "taula de temperatures (3h)",
      "TA_table_season": "taula de temperatures (temporada)"
    }
  },
  "grainShape": {
    "PP": {
      "code": "PP",
      "class": "Partícules de precipitació"
    },
    "PPgp": {
      "code": "PPgp",
      "class": "Neu granulada"
    },
    "DF": {
      "code": "DF",
      "class": "Partícules de precipitació descompostes i fragmentades"
    },
    "RG": {
      "code": "RG",
      "class": "Grans fins"
    },
    "FC": {
      "code": "FC",
      "class": "Facetes"
    },
    "FCxr": {
      "code": "FCxr",
      "class": "Rounding Faceted Crystals"
    },
    "DH": {
      "code": "DH",
      "class": "Gobelets"
    },
    "SH": {
      "code": "SH",
      "class": "Gebre de superfície"
    },
    "MF": {
      "code": "MF",
      "class": "Formes de fusió"
    },
    "MM": {
      "code": "MM",
      "class": "Machine Made"
    },
    "MFcr": {
      "code": "MFcr",
      "class": "Crosta de fusió-regel"
    },
    "IF": {
      "code": "IF",
      "class": "Formacions de gel"
    }
  },
  "button": {
    "true": "Si",
    "false": "No",
    "ok": "D'acord",
    "yes": "Si",
    "no": "No"
  },
  "observations": {
    "$externalURL": "External URL (e.g. to photo database)",
    "$type": "Observation type",
    "allowEdit": "Editar observació externa",
    "allowEditTooltip": "Això evitarà les sobreescriptures de {{ value }}",
    "editIconTooltip": "Observació editada: no rep actualitzacions de {{ value }}",
    "aspect": "Orientació",
    "authorName": "Nom de l'autor",
    "avalancheLength": "Longitud d'allau",
    "avalancheProblem": "Problema d'allaus",
    "avalancheProblems": "Avalanche problem",
    "avalancheSize": "Mida d'allau",
    "avalancheType": "Tipus d'allau",
    "avalancheWidth": "Amplada d'allau",
    "search": "Cerca",
    "count": "# observacions:",
    "elevationTolerance": "Precisió de les dades d'altitud",
    "elevationPeriod": "Període de temps d'altitud",
    "layers": {
      "observers": "Observadors",
      "weatherStations": "Estacions meteorològiques",
      "webcams": "Webcams",
      "observations": "Observacions"
    },
    "weatherStations": {
      "tooltips": {
        "drySnowfallLevel": "Cota de neu seca de la nevada",
        "globalRadiation": "Radiació global",
        "newSnow": "Neu recent",
        "snowLine": "Límit de neu",
        "snowHeight": "Alçada de la neu",
        "snowDifference": "Diferència de neu",
        "airTemperature": "Temperatura de l'aire",
        "airTemperatureMax": "Temperatura de l'aire màxima",
        "airTemperatureMin": "Temperatura de l'aire mínima",
        "surfaceTemperature": "Temperatura de superfície",
        "surfaceHoar": "Potencial de formació de gebre de superfície",
        "surfaceHoarCalc": "Potencial de formació de gebre de superfície (Lehning et. al.)",
        "dewPoint": "Temperatura del punt de rosada",
        "relativeHumidity": "Humitat relativa",
        "windDirection": "Direcció del vent",
        "windSpeed": "Velocitat del vent",
        "windGust": "Ràfega de vent"
      }
    },
    "webcams": {
      "tooltips": {
        "minusTenMinutes": "10 minuts enrere",
        "minusOneHour": "1h enrere",
        "plusTenMinutes": "10 minuts endavant",
        "plusOneHour": "1h endavant"
      }
    },
    "button": {
      "add": "Afegir observació",
      "save": "Guardar observació",
      "delete": "Eliminar observació",
      "deleteConfirm": "Eliminar observació?",
      "discard": "Descarta",
      "copyDate": "Copiar la data de l'esdeveniment"
    },
    "comment": "Comentari",
    "content": "Contingut",
    "dangerPatterns": "Danger patterns",
    "dangerRating": "Grau de perill",
    "dangerSource": "Font de perill",
    "elevation": "Altitud",
    "elevationRange": "Rang d'altitud",
    "elevationLowerBound": "Límit inferior d'altitud",
    "elevationUpperBound": "Límit superior d'elevació",
    "eventDate": "Data d'esdeveniment",
    "eventType": "Tipus d'esdeveniment",
    "eventTypes": {
      "IMPORTANT": "Esdeveniment important",
      "NEIGHBOR_REGION": "Regió veïna",
      "NORMAL": "Esdeveniment normal",
      "PERSON_DEAD": "Esdeveniment amb persones implicades (mortes)",
      "PERSON_INJURED": "Esdeveniment amb persones implicades (ferides)",
      "PERSON_NO": "Esdeveniment sense persones implicades",
      "PERSON_UNINJURED": "Esdeveniment amb persones implicades (il·leses)",
      "PERSON_UNKNOWN": "Esdeveniment (desconegut)",
      "TRAFFIC": "Trànsit"
    },
    "externalURL": "URL externa (per exemple, a la base de dades de fotos)",
    "fractureDepth": "Profunditat cicatriu",
    "hasCoordinates": "Té coordenades",
    "incline": "Pendent",
    "importantObservations": "Important observations",
    "latitude": "Laltitud",
    "locationName": "Localitat",
    "longitude": "Longitud",
    "observationType": "Tipus d'observació",
    "personInvolvement": "Implicació de persones",
    "reportDate": "Data de l'informe",
    "showTable": "Taula",
    "stability": "Snowpack Stability",
    "withoutCoordinates": "Observacions sense coordenades:",
    "sidebar": {
      "filter": {
        "title": "Filtre"
      },
      "legend": {
        "title": "Llegenda"
      },
      "sources": {
        "title": "Fonts de dades"
      },
      "views": {
        "title": "Vistes"
      }
    }
  },
  "personInvolvement": {
    "Dead": "Esdeveniment amb persones implicades (mortes)",
    "Injured": "Esdeveniment amb persones implicades (ferides)",
    "Yes": "Event involving persons",
    "No": "Esdeveniment sense persones implicades",
    "Uninjured": "Esdeveniment amb persones implicades (il·leses)",
    "Unknown": "Esdeveniment (desconegut)"
  },
  "units": {
    "cm": "cm",
    "mm": "mm",
    "m": "m"
  },
  "qfa": {
    "day": "Dia",
    "time": "Hora",
    "back": "Enrera",
    "parameters": {
      "DUST": "pols sahariana",
      "N": "Cobertura de núvols total en /8",
      "Nh": "Cobertura de núvols alts en /8",
      "Nm": "Cobertura de núvols mitjans en /8",
      "Nl": "Cobertura de núvols baixos en /8",
      "N-CU": "Cobertura de núvols cumulus en /8",
      "AUSL.T": "temperatura desencadenant",
      "SHW-IX": "Index Showalter",
      "WX -CUF": "Temps significatiu: NIL (cap), RASH (pluja), TS (tempesta)",
      "RR": "precipitaió total [mm]",
      "RR-str": "precipitatió estratiforme",
      "CONV": "precipitació convectiva [mm]",
      "SN": "precipitació en forma de neu [mm]",
      "SN--RA": "límit de la neu [m]",
      "QAO ": "{{value}} hPa eq. vent mitjà, direcció i velocitat, [°] i [m/s]",
      "QAN": "vent mitjà al terra, direcció i velocitat, [º] i [m/s]",
      "QANmax": "vent màx. (ràfagues) al terra [m/s]",
      "T ": "{{value}} hPa eq. temperatura [°C]",
      "T m": "temperatura a {{value}}m [°C]",
      "T 2m": "temperatura a 2m [°C]",
      "Tk 2m": "temperatura a 2m [°K]",
      "T GND": "temperatura al terra",
      "Max-ADI": "temperatura màxima de barreja [°C]",
      "Min Max": "temperatura mín./màx. en les darreres 24h",
      "FROST": "alçada isozero [m]",
      "W cm": "500 hPa eq. vent vertical [cm/s]",
      "W --": "700 hPa eq. vent vertical [cm/s]",
      "W s": "{{value}} hPa eq. vent vertical [cm/s]",
      "H ": "{{value}} hPa alçada geopotencial [m]",
      "RF ": "{{value}} hPa eq. humitat relativa [%]"
    }
  },
  "awsome": {
    "Aggregation band": "Banda d'agregació",
    "Date": "Data",
    "Datetag": "Etiqueta de data",
    "Depth": "Profunditat",
    "Dry instability": "Inestabilitat de neu seca",
    "fair (<0.77)": "regular (<0.77)",
    "fair (<1.05)": "regular (<1.05)",
    "Grain type": "Tipus de gra",
    "LWC index": "Índex LWC",
    "New snow": "Neu recent",
    "poor (<=3)": "pobre (<=3)",
    "poor (<0.95)": "pobre (<0.95)",
    "poor (>=0.77)": "pobre (>=0.77)",
    "Punstable": "Puntable",
    "rather stable (<0.7)": "força estable (<0.7)",
    "rather stable (<1)": "força estable (<1)",
    "rather stable (>1.05)": "força estable (<1.05)",
    "Size estimate": "Estimació de la mida",
    "SK38 (RTA > 0.8)": "SK38 (RTA > 0.8)",
    "very poor (<=0.5)": "molt pobre (<=0.5)",
    "very poor (>3)": "molt pobre (>3)",
    "Wet instability": "Inestabilitat de neu humida"
  },
  "channelStatus": {
    "loading": "S'està carregant la informació de l'estat del canal...",
    "triggerStatusChecks": "Desencadenar comprovacions d'estat"
  },
  "lineaexport": {
    "searchfieldplaceholder": "Cercar estacions...",
    "hint": "Prémer Intro per afegir"
  },
  "awsstats": {
    "title": "AWS statistics",
    "label": {
      "loading": "Loading data...",
      "startDate": "Start date",
      "endDate": "End date",
      "selectWeatherStation": "Select weather station",
      "selectMicroRegions": "Select micro-regions",
      "clearselection": "Clear selection",
      "noMicroRegionsSelected": "cap",
      "last7days": "Last 7 days",
      "last30days": "Last 30 days",
      "last90days": "Last 90 days",
      "loadData": "Load data",
      "charttypes": "Chart types"
    },
    "charts": {
      "aws-observations": "AWS observations",
      "aws-danger-rating": "Grau de perill",
      "aws-danger-rating-altitude": "Danger rating by altitude",
      "aws-avalanche-activity-index": "Avalanche activity index",
      "aws-danger-rating-danger-source-variants": "Danger source variants",
      "aws-danger-source-variants-matrix-parameter-stability": "Danger source variants stability",
      "aws-danger-source-variants-matrix-parameter-frequency": "Danger source variants frequency",
      "aws-danger-source-variants-matrix-parameter-avalanche-size": "Danger source variants avalanche size"
    },
    "error": {
      "startDateBeforeEndDate": "Start date must be before or equal to end date.",
      "failedLoadData": "Failed to load data for selected date range.",
      "startDateEndDateRequired": "Start date and end date are required."
    }
  },
  "yearlystats": {
    "title": "Yearly Statistics",
    "label": {
      "startDate": "Start date",
      "endDate": "End date",
      "loaddata": "Load data",
      "last90Days": "Last 90 days",
      "last180Days": "Last 180 days",
      "currentSeason": "Current season",
      "regionCode": "Region code",
      "allRegions": "TOTS",
      "virtualTrainings": "Virtual trainings (dates)",
      "fieldTrainings": "Field trainings (dates)",
      "dangerRatingReference": "Danger rating reference"
    },
    "charts": {
      "aws-danger-rating-micro-regions-bars": "AWS Danger Rating - Micro Regions - Bars",
      "aws-danger-rating-micro-regions": "AWS Danger Rating - Micro Regions",
      "aws-danger-rating-distribution": "AWS Danger Rating - Distribution",
      "aws-danger-pattern-micro-regions": "AWS Danger Pattern - Micro Regions",
      "aws-avalanche-problem-micro-regions": "AWS Avalanche Problem - Micro Regions",
      "aws-products": "AWS Products",
      "aws-stress-level": "Team Stress Level"
    },
    "hint": {
      "dangerRatingReference": "Reference values for a danger rating distribution over different seasons, shown in grey",
      "dateChange": "After changing the date, the 'Load data' button must be pressed."
    }
  },
  "zodForm": {
    "valid": "Valid",
    "required": "Required",
    "invalidNumber": "Please enter a valid number."
  }
}
